var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[(_vm.type === 'kaali')?_c('KaaliTitle',{attrs:{"title":_vm.title,"description":_vm.description,"displayHR":_vm.displayHR}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }